import './bar_chart_view.js.coffee';# Added by Script 
import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.FansMetadataView extends Monitoring.Reports.Executive.BarChartView 
  genericTemplate: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  tagName: 'section'
  chartClass: 'column-chart'
  icon: 'column'

  initialize: (@options = {}) ->
    @colors = @options.colors
    @target = { fans_metadata: @options.chartApi.fans_metadata}

  _columnOptions: (response, divId) =>
    hashSeries = {}
    hashSeries["Alcance de la fan page"] = [response["reach"] || 0, 0]
    hashSeries["Total usuarios de Argentina"] = [0, response["argentina"] || 0]

    series = _.map(hashSeries, (values, index) => { name: index, data: values, color: @colors[index.toLowerCase()] })
    serie.type = 'column' for serie in series
    categories = ["Alcance de la fan page", "Total usuarios de Argentina"]

    @highchartsBarOptions(divId, series, categories)
